import GrammaPro from './model';
import create from './create';

GrammaPro.create = create;

export default GrammaPro;



// WEBPACK FOOTER //
// ./data/GrammaPro/model/index.js